/**
 * @description: 欢迎词设置
 * @author: hwx
 */
<template>
	<div class="welcome-template-wrap">
		<div class="welc-list" v-show="showList">
			<!-- <h1>欢迎词设置</h1> -->
			<el-col class="row-margin">
				<el-button type="primary" @click="welcAdd">欢迎词设置</el-button>
				<el-button type="text" @click="welcShowImg">欢迎词样例</el-button>
			</el-col>
			<el-form :inline="true" :model="welc_list_form">
				<el-form-item label="门店">
					<el-select v-model="welc_list_form.shop_id" filterable clearable placeholder="请选择门店">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入内容" v-model="welc_list_form.content">
						<el-select class="el-slot-select" v-model="welc_list_form.select" slot="prepend" placeholder="请选择">
							<el-option label="欢迎词标题" value="1"></el-option>
							<el-option label="模板名称" value="2"></el-option>
						</el-select>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="welcQuery">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="welc_list">
				<el-table-column prop="shop_name" label="门店"></el-table-column>
				<el-table-column prop="name" label="模板名称"></el-table-column>
				<el-table-column prop="img" label="背景图">
					<template slot-scope="scope">
						<img :src="scope.row.img">
					</template>
				</el-table-column>
				<el-table-column prop="title" label="欢迎词标题"></el-table-column>
				<el-table-column prop="content" label="欢迎词内容"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="welcModify(scope.row)">修改</span>
						<span class="text-blue" @click="welcDel(scope.row.id)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="welc_list_page"
				:total="welc_list_total"
				@current-change="getWelcList">
			</el-pagination>
		</div>
		<div class="welc-edit" v-show="!showList">
			<div class="page-tit">{{edit_tit}}</div>
			<p>注：</p>
			<p>1，适用场景：贵宾到包厢消费后可以设置的欢迎词，对贵宾表示欢迎。</p>
			<p>2，设置：智慧商家桌面版设置欢迎词模板 > 智慧商家app预定管理添欢迎词 > 开房后包厢电视显示欢迎词。</p>
			<el-form ref="edit_form" :model="edit_form" label-width="120px">
				<el-form-item label="门店">
					<el-select v-model="edit_form.shop_id" filterable clearable placeholder="请选择门店">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模板名称">
					<el-input maxlength="15" show-word-limit placeholder="请输入模板名称，例如：男士生日欢迎词模板" v-model="edit_form.name"></el-input>
				</el-form-item>
				<el-form-item label="欢迎词标题">
					<el-input maxlength="15" show-word-limit placeholder="请输入欢迎词标题，例如：尊敬的林先生" v-model="edit_form.title"></el-input>
				</el-form-item>
				<el-form-item label="欢迎词内容">
					<el-input
					type="textarea"
					placeholder="请输入欢迎词内容"
					:autosize="{ minRows: 7 }"
					maxlength="200"
					show-word-limit
					v-model="edit_form.content"></el-input>
				</el-form-item>
				<el-form-item label="背景图">
					<div class="welc-dash">
						<div class="clearfix">
							<p>请上传欢迎词背景图（1张），图片尺寸为：1280*720 ， png /jpg格式</p>
							<img :src="edit_form.img" id="editImg">
							<el-button type="primary" @click="showImgTemp">选择背景图模板</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button @click="backList">返回</el-button>
					<el-button type="primary" @click="editSub">确定</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="welc-big-img" ref="welc_big_img">
			<img src="../../assets/images/welc_temp_img.jpg" alt="">
		</div>
		<div class="welc-img-template" ref="welc_img_template">
			<div>
				<img src="https://vodonline.oss-cn-beijing.aliyuncs.com/ktv/uploads/welcomeTemps/bg1.png" @click="getImgTemp('https://vodonline.oss-cn-beijing.aliyuncs.com/ktv/uploads/welcomeTemps/bg1.png')">
				<img src="https://vodonline.oss-cn-beijing.aliyuncs.com/ktv/uploads/welcomeTemps/bg2.png" @click="getImgTemp('https://vodonline.oss-cn-beijing.aliyuncs.com/ktv/uploads/welcomeTemps/bg2.png')">
				<img src="https://vodonline.oss-cn-beijing.aliyuncs.com/ktv/uploads/welcomeTemps/bg3.png" @click="getImgTemp('https://vodonline.oss-cn-beijing.aliyuncs.com/ktv/uploads/welcomeTemps/bg3.png')">
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,
				modify: '1',
				loading: false,
				shop_list: [],
				welc_list_form: {
					shop_id: '',
					content: '',
					select: '1',
				},
				welc_list: [],
				welc_list_page: 1,
				welc_list_total: 0,
				edit_id: '',
				edit_tit: '',
				edit_form: {
					shop_id: '',
					name: '',
					title: '',
					content: '',
					img: require('../../assets/images/upload_btn.png'),
				}
			}
		},
		mounted: function() {
			this.getShop();
			this.editImgUpload();
		},
		methods: {
			// 获取门店数据
			getShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.getWelcList(1);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 列表
			getWelcList(page) {
				const _this = this;

				_this.loading = true;
				let title = '',
					name = '';
				if(_this.welc_list_form.select == '1') {
					title = _this.welc_list_form.content;
				} else {
					name = _this.welc_list_form.content;
				}
				Vue.axios.post('Setting/getWelcomeTempsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"shop_id": _this.welc_list_form.shop_id,
							"title": title,
							"name": name,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.welc_list_total = Number(res.data.response.result.total);
						}
						_this.welc_list = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			welcQuery() {
				this.getWelcList(1);
			},
			// 删除
			welcDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Setting/delWelcomeTemp', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getWelcList(_this.welc_list_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},
			// 赛事logo图上传
			editImgUpload: function() {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				// 实例化一个plupload上传对象
				let uploader = new plupload.Uploader({
					browse_button: 'editImg', // 选择文件id
					filters: {
						mime_types: [ // 文件格式限制
							{ title: "Image files", extensions: "jpg,png" }
						],
						// max_file_size: '2mb', // 文件大小限制
						prevent_duplicates: true // 不允许选取重复文件
					},
					resize: {
						width: 1280,
						height: 720
					},
					multi_selection: false, // 单选
					url: './', // OSS地址
					init: {
						// 文件上传前触发
						BeforeUpload: function(up, file) {},
						// 文件选择完毕触发
						FilesAdded: function(up, files) {
							// 获取签名
							Vue.axios.post('publicData/api_getOssSignature', {
								"header": Vue.request_header,
								"request": {
									"version": Vue.version,
									"param": {
										"file": files[0].name,
										"path": 'Setting'
									}
								},
								"comment": ""
							})
							.then(res => {
								if(res.data.response.result_code == "true") {
									host = res.data.response.data.host;
									dir = res.data.response.data.dir;
									file_name = res.data.response.data.file_name;
									const new_params = {
										'key': dir + file_name,
										'OSSAccessKeyId': res.data.response.data.accessid,
										'policy': res.data.response.data.policy,
										'signature': res.data.response.data.signature,
										'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
									};
									up.setOption({
										'url': host,
										'multipart_params': new_params
									});

									// 上传文件
									uploader.start();
								} else {
									Vue.timeoutfun(data.response.result_status, _this);
									layer.msg(data.response.error_msg);
								}
							})
							.catch(err => {
								layer.msg("出错啦");
							});
						},
						// 文件上传成功触发
						FileUploaded: function(up, file, data) {
							$('#editImg').attr('suc', '1');
							_this.edit_form.img = host + "/" + dir + file_name;
							layer.msg('上传成功');
						},
						// 错误提示
						Error: function(up, err) {
							if(err.code == -600) {
								layer.msg('请选择2mb以内的文件');
							} else if (err.code == -601) {
								layer.msg('只允许上传png文件');
							} else if (err.code == -602) {
								layer.msg('这个文件已经上传过一遍了');
							} else {
								layer.msg(err.response);
							}
						}
					}
				});
				// 初始化
				uploader.init();
			},
			// 点击新增
			welcAdd() {
				this.modify = '1';
				this.edit_tit = '新增欢迎词';
				this.edit_form = {
					shop_id: '',
					name: '',
					title: '',
					content: '',
					img: require('../../assets/images/upload_btn.png'),
				};
				this.showList = false;
			},
			// 欢迎词样例
			welcShowImg() {
				const _this = this;
				layer.open({
					type: 1,
					title: '欢迎词样例',
					skin: 'public-alert-skin',
					area: ['660px', ''], //宽高
					content: $(_this.$refs.welc_big_img)
				});
			},
			// 点击修改
			welcModify(row) {
				this.modify = '2';
				this.edit_id = row.id;
				this.edit_tit = '修改欢迎词';
				this.edit_form = {
					shop_id: row.shop_id,
					name: row.name,
					title: row.title,
					content: row.content,
					img: row.img,
				};
				this.showList = false;
			},
			// 背景图模板
			showImgTemp() {
				const _this = this;
				layer.open({
					type: 1,
					title: '背景图模板',
					skin: 'public-alert-skin',
					area: ['700px', ''], //宽高
					content: $(_this.$refs.welc_img_template)
				});
			},
			getImgTemp(url) {
				$('#editImg').attr('suc', '1');
				this.edit_form.img = url;
				layer.closeAll();
			},
			// 新增、修改
			editSub() {
				const _this = this;

				let url = "Setting/addWelcomeTemp";
				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.edit_form.shop_id,
							"name": _this.edit_form.name,
							"title": _this.edit_form.title,
							"content": _this.edit_form.content,
							"img": _this.edit_form.img
						}
					},
					"comment": ""
				};
				if(_this.modify == '2') {
					data.request.param.id = _this.edit_id;
					url = "Setting/updateWelcomeTemp";
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getWelcList(_this.welc_list_page);
						_this.showList = true;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 返回列表
			backList() {
				this.showList = true;
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.welc-list {
		img {
			display: block;
			width: 50px;
		}
	}
	.welc-edit {
		p {
			line-height: normal;
			color: #ff0707;
		}
		.el-form {
			width: 620px;
			.el-select {
				width: 100%;
			}
		}
	}
	.welc-dash {
		padding: 0;
		>div {
			width: 500px;
			padding: 20px 15px;
			border: 1px dashed #CCC;
		}
		p {
			margin: 0 0 30px;
			font-size: 12px;
		}
		img {
			float: left;
			width: 114px;
			height: 114px;
			margin: 0 39px 0 0;
			cursor: pointer;
		}
	}
	.welc-big-img {
		display: none;
		img {
			display: block;
			width: 100%;
		}
	}
	.welc-img-template {
		display: none;
		div {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}
		img {
			float: left;
			width: 300px;
			margin: 0 0 30px;
			cursor: pointer;
		}
	}
</style>